import * as React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';
import Sidebar from '../components/sidebar'
import Footer from '../components/footer'
import Head from '../components/head'
import 'react-quill/dist/quill.snow.css'; // Import Quill's CSS for styling
import { api } from '../api'

export default function Main() {

  const [message, setMessage] = useState("");
  const [user, setUser] = useState();
  const [form, setForm] = useState({
     
      title: "",
      des: "",
      keyword: "",
      slug: "",
      img: "",
      imgalt: "",
      ex1: "",
      ex2: "",
      ex3: "",
      ex4: "",
      ex5: "",
      views:""

    });
  
    const handleChange = (e) => {
      setForm({ ...form, [e.target.name]: e.target.value });
    };
  
const handleSubmit = async () => {
  const formData = new FormData();
  
  Object.entries(form).forEach(([key, value]) => {
    formData.append(key, value);
  });

  formData.append('status', selectedStatus);
  formData.append('cat', selectedCat);
  formData.append('tags', JSON.stringify(tags));
  formData.append('uid', user?.[0]?.id || '');

  try {
    const response = await fetch(`/api/royal_blogs/blogs_add.php`, {
      method: "POST",
      body: formData
    });

    // Check if response is OK
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const text = await response.text();
    console.log('Raw response:', text); // Debug log

    let result;
    try {
      result = JSON.parse(text);
    } catch (parseError) {
      console.error('JSON parse error:', parseError);
      throw new Error('Invalid JSON response from server');
    }

    setMessage(result[0]?.msg || "Unknown response");
  } catch (err) {
    console.error("Error:", err);
    setMessage("Failed to update! " + err.message);
  }
};

    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedCat, setSelectedCat] = useState('');

const handleChange_status = (e) => {
  setSelectedStatus(e.target.value);
};
const handleChange_Cat = (e) => {
  setSelectedCat(e.target.value);
};


  useEffect(() => {

   const user_d= localStorage.getItem("admin")
   setUser(JSON.parse(user_d))
    get_cat(4);
    get_status(4);
  }, []);


 const [cat,setCat]=useState([])
 const [status,setStatus]=useState([])

  const get_status = async (id)=> {
    const data = new FormData();
    // data.append('id',id);
    axios({
              method: 'post',
              url:'/api/royal_blogs/blogs_status_action.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
                setStatus(s.data)
                console.log(s.data)
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

  const get_cat = async (id)=> {
    const data = new FormData();
    
    // data.append('id',id);

            axios({
              method: 'post',
              url: '/api/royal_blogs/blogs_cat_list.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
                setCat(s.data)
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

          const [tags, setTags] = useState([]);
          const [tagName, setTagName] = useState("");
          const [tagUrl, setTagUrl] = useState("");
        
          const addTag = () => {
            if (tagName.trim()) {
              setTags([...tags, { name: tagName.trim(), url: tagUrl.trim() }]);
              setTagName("");
              setTagUrl("");
            }
          };

          const removeTag = (nameToRemove) => {
            setTags(tags.filter((tag) => tag.name !== nameToRemove));
          };

  return (
    <>
     <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
       <Head />
       <div>
{/* 2 */}
        <div className="page-content">
   

        <div>
        <div className="container py-5">
      <h2 className="mb-4">New Blog  </h2>

<div className="d-flex flex-column align-items-end justify-content-end">
  <button type="button" onClick={handleSubmit} className="btn btn-primary p-3">
    Apply
  </button>
  {message && <div className="alert alert-info mt-3">{message}</div>}
</div>

        <div className="row g-3">
        <div className="col-md-6" >
              <label  className="form-label">Status </label>
              <select onChange={handleChange_status} value={selectedStatus}  className="form-control">
                  {
                   status.map((v) => (
                    <option key={v.value} value={v.value}>{v.name}</option>
                  ))
                  }
                </select>
              
            </div>
        {/* <div className="col-md-3" >
              <label  className="form-label">
              Category  
              </label>
              <select onChange={handleChange_Cat} value={selectedCat} className="form-control">

                  {
                   cat.map((v) => (
                    <option key={v.value} value={v.value}>{v.name}</option>
                  ))
                  }
                  


                </select>
              
            </div> */}

          {Object.entries(form).map(([key, value]) => (
            <div className="col-md-6" key={key}>
              <label htmlFor={key} className="form-label text-capitalize">                
              {
                key=="ex1"?"H1":key=="ex2"?"H1 Description":
                key=="imgalt"?" Image alt text":key.replace(/_/g, " ")
              }
              </label>
              <input type={ "text"} className="form-control"
                id={key}
                name={key}
                value={value}
                onChange={handleChange}
                required={key === "title"}
              />
            </div>
          ))}




        </div>


<br/>

<div className='card p-3'>


<div className='row '>
  <div className='col-6'>
<label>Tag</label>
<input
          value={tagName}
          onChange={(e) => setTagName(e.target.value)}
          placeholder="Tag"
          className="form-control"
        />

  </div>
  <div className='col-4'>
<label>URL</label>
  <input
            value={tagUrl}
            onChange={(e) => setTagUrl(e.target.value)}
            placeholder="Tag URL"
            className="form-control"
        />

  </div>
  <div className='col-2'>
  <br/>
  <button onClick={addTag} className="form-control btn btn-primary">Add </button>
  </div>

</div>
</div>
<div className='card p-3 mt-2'>  
<div className="p-4">
  <table className="min-w-full border rounded-lg overflow-hidden">
    <thead className="bg-gray-100">
      <tr>
        <th className="text-left px-4 py-2 border-b">Tag</th>
        <th className="text-left px-4 py-2 border-b">URL</th>
        <th className="text-left px-4 py-2 border-b">Action</th>
      </tr>
    </thead>
    <tbody>
      {tags.map((tag) => (
        <tr key={tag.name} className="hover:bg-gray-50">
          <td className="px-4 py-2 border-b">{tag.name}</td>
          <td className="px-4 py-2 border-b">
            <a
              href={tag.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              {tag.url}
            </a>
          </td>
          <td className="px-4 py-2 border-b">
            <button
              onClick={() => removeTag(tag.name)}
              className="btn btn-primary"
            >
              Remove
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
</div>




    
    

          <button type="submit" onClick={handleSubmit} className="btn btn-primary mt-4">
          Apply
        </button>
  

        {message && <div className="alert alert-info mt-3">{message}</div>}
     
    </div>
        </div>

</div>

    </div>
     
  
       
        <Footer/>
       
      </div>
    </div>
  </>

  )
}
